/*
 * @FilePath: index.js
 * @Author: chenwei
 * @Date: 2022-07-15 09:06:36
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-18 11:08:33
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
import {proxyHeader} from "@/utils/config"
import signMd5Utils from '@/utils/encryption/signMd5Utils'
import axios from 'axios'
import {post, get} from '@/utils/request'

export function getAction(url, parameter) {
  let sign = signMd5Utils.getSign(url, parameter);
  //将签名和时间戳，添加在请求接口 Header
  let signHeader = {"X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToString()};

  return axios({
    url: proxyHeader + url,
    method: 'get',
    params: parameter,
    headers: signHeader
  })
}

//注销
export const logout = p => post(proxyHeader + 'service/security-service/sys/logout', p);

//验证码
export const captcha = p => get(proxyHeader + 'service/security-service/sys/randomImage/' + p);

//注册用户
export const createUser = p => post(proxyHeader + 'service/security-service/hyUser/add', p);

//从第三方登录获取token  
export const getParameterToken = p => get(proxyHeader + 'service/security-service/sys/cas/client/ssoLogin', p);


